import { render } from "./OnlinePage.vue?vue&type=template&id=0fdba030"
import script from "./OnlinePage.vue?vue&type=script&lang=js"
export * from "./OnlinePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__